import { PriceSummaryBadgeType, RowProps } from '../types';

export const getDiscountBadge = (
  percentage?: number,
  type: PriceSummaryBadgeType = 'Discount'
): RowProps['badge'] => {
  if (!percentage) {
    return undefined;
  }

  return {
    content: `-${Math.abs(percentage)}%`,
    type,
  };
};
